<template>
  <div
    v-show="isSelected"
    :id="`aw-${awTabUuid}-tabpanel-${tabIndex}`"
    tabindex="0"
    role="tabpanel"
    :aria-labelledby="`aw-${awTabUuid}-tab-${tabIndex}`"
  >
    <slot v-if="keepDom || isSelected" />
  </div>
</template>

<script>
  import { mapState } from 'pinia';
  import { useRoute } from 'nuxt/app';
  import { useTabStore } from '~~/common/stores/tab';

  export default {
    name: 'AwTabContentVersion2',
    inject: {
      awTabUuid: {
        from: 'uuid',
      },
    },
    props: {
      tabIndex: {
        type: [String, Number],
        default: 0,
      },
      keepDom: {
        type: Boolean,
        default: true,
      },
      routePath: {
        type: String,
        default: '',
      },
      alternativeRoutePaths: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      ...mapState(useTabStore, {
        isSelected (state) {
          const route = useRoute();
          if (this.routePath) {
            return route.path === this.routePath || this.alternativeRoutePaths.includes(route.path);
          } else {
            return state.tabs[this.awTabUuid] === this.tabIndex;
          }
        },
      }),
    },
  };
</script>

<style module lang="scss" rel="stylesheet/scss">
.tab {
  display: flex;
}
</style>
